import React from "react";
import { MapPin, Zap, Activity, Trophy, Heart, Droplet, Wind, Hospital, Leaf, Sparkles } from "lucide-react";

const CITIES = [
  "Istres", "Fos-sur-Mer", "Miramas", "Saint-Mitre-les-Remparts",
  "Port-de-Bouc", "Martigues", "Salon-de-Provence", "Vitrolles",
  "Marignane", "Berre-l'Étang", "Rognac", "Lançon-Provence",
  "Cornillon-Confoux", "Grans", "Saint-Chamas",
];

const SERVICES = [
  { label: "Électrostimulation EMS", icon: Zap },
  { label: "Drainage lymphatique corps entier", icon: Droplet },
  { label: "Drainage ventre & jambes", icon: Droplet },
  { label: "Drainage post-opératoire", icon: Hospital },
  { label: "Drain & Sculpt corps entier", icon: Wind },
  { label: "Drain & Sculpt haut du corps", icon: Wind },
  { label: "Drain & Sculpt bas du corps", icon: Wind },
  { label: "Madérothérapie", icon: Leaf },
  { label: "Duo EMS + Massage", icon: Sparkles },
  { label: "Cures 5 séances", icon: Heart },
  { label: "Sport & performance", icon: Trophy },
  { label: "Remise en forme à domicile", icon: Activity },
];

export default function MarqueeBand() {
  const citiesLoop = [...CITIES, ...CITIES];
  const servicesLoop = [...SERVICES, ...SERVICES];

  return (
    <section
      className="relative overflow-hidden mt-6"
      aria-label="Zones et services"
      data-testid="marquee-band"
    >
      {/* Top band — services, green bg, white text, scrolling LEFT */}
      <div className="bg-fegreen py-2.5 sm:py-3 overflow-hidden">
        <div className="flex marquee-track whitespace-nowrap will-change-transform">
          {servicesLoop.map((s, i) => {
            const Icon = s.icon;
            return (
              <span
                key={`s-${i}`}
                className="inline-flex items-center gap-3 mx-8 sm:mx-12 text-white text-base sm:text-lg lg:text-xl font-light tracking-wide"
              >
                <Icon className="w-4 h-4 sm:w-5 sm:h-5 shrink-0 opacity-80" strokeWidth={1.5} />
                <span>{s.label}</span>
                <span className="text-white/40 mx-2 font-light">✦</span>
              </span>
            );
          })}
        </div>
      </div>

      {/* Bottom band — cities, white bg, green text, scrolling RIGHT (reverse) */}
      <div className="bg-white py-2.5 sm:py-3 overflow-hidden border-y border-fegray-light">
        <div className="flex marquee-track-reverse whitespace-nowrap will-change-transform">
          {citiesLoop.map((c, i) => (
            <span
              key={`c-${i}`}
              className="inline-flex items-center gap-3 mx-8 sm:mx-12 text-fegreen text-base sm:text-lg lg:text-xl font-light tracking-wide"
            >
              <MapPin className="w-4 h-4 sm:w-5 sm:h-5 shrink-0 opacity-80" strokeWidth={1.5} />
              <span>{c}</span>
              <span className="text-fegray/30 mx-2 font-light">·</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
